import Microcosm from 'microcosm'
import Indexing from 'microcosm/addons/indexing'

import Strategies from './domains/strategies'
import Factors from './domains/factors'
import FactorCorrelations from './domains/factor-correlations'
import UI from './domains/ui'
import Locale from './domains/locale'
import Document from './effects/document'

// Install the indexing compatability layer
Indexing()

class Repo extends Microcosm {
  setup() {
    this.addDomain('ui', UI)
    this.addDomain('strategies', Strategies)
    this.addDomain('factors', Factors)
    this.addDomain('factorCorrelations', FactorCorrelations)
    this.addDomain('locale', Locale)

    this.addEffect(Document)
  }
}

export default Repo



// WEBPACK FOOTER //
// ./src/repo.js